var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 14.25C11.75 12.5931 9.73528 11.25 7.25 11.25C4.76472 11.25 2.75 12.5931 2.75 14.25M13.25 10.5L14.75 8.99999M14.75 8.99999L16.25 7.5M14.75 8.99999L13.25 7.5M14.75 8.99999L16.25 10.5M7.25 9C5.59315 9 4.25 7.65685 4.25 6C4.25 4.34315 5.59315 3 7.25 3C8.90685 3 10.25 4.34315 10.25 6C10.25 7.65685 8.90685 9 7.25 9Z",
    stroke: "#2D53DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserClose);
export default __webpack_public_path__ + "static/media/User_Close.f5dec3a35bcdfe6c80d28621b237eb7b.svg";
export { ForwardRef as ReactComponent };